import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiTableBody,
  TableBodyProps,
} from '@mui/material/TableBody';

const TableBody: FunctionComponent<TableBodyProps> = (
  props: PropsWithChildren<TableBodyProps>
) => {
  return <MuiTableBody {...props}>{props.children}</MuiTableBody>;
};

export default TableBody;
